import React from 'react';
import PropTypes from 'prop-types';
import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import Loading from 'react/components/Loading';

import resources from 'react/containers/pages/TicketDetails/ticketDetailsResources';
import { resourceFrom, formatDate } from 'react/containers/pages/TicketDetails/ticketDetailsUtils';
import AttachmentChatItem from 'react/containers/pages/TicketDetails/TicketDetailsContainer/AttachmentChatItem';

const renderContent = (data) => {
  if (!data?.get || (!data.get('id') || !data.get('chats'))) {
    return <div>{resourceFrom(resources.dataNotFound)}</div>;
  }

  if (data.get('chats')?.size) {
    const createdDate = data.get('created') && formatDate(data.get('created'));
    return (
      <FormSectionColumn>
        <div className="attachmentsSection__messageHistory">
          <div className="attachmentsSection__title">{resourceFrom(resources.messageHistory)}</div>
          <div className="attachmentsSection__messages">
            <div className="attachmentsSection__messageTicket">
              <span>{`${resourceFrom(resources.ticketOpenedAt)} ${createdDate}`}</span>
            </div>
            {data.get('chats').map((chat) => (
              <AttachmentChatItem key={chat.get('id')} chat={chat} />
            ))}
          </div>
        </div>
      </FormSectionColumn>
    );
  }

  return <div className="attachmentsSection__messages">{resourceFrom(resources.noChatsToShow)}</div>;
};

function AttachmentsSection(props) {
  const { isLoadingChatData, data } = props;

  return (
    <FormSection title="TicketDetails.section.attachments.title" className="attachmentsSection">
      {isLoadingChatData
        ? <Loading />
        : renderContent(data)}
    </FormSection>
  );
}

AttachmentsSection.propTypes = {
  isLoadingChatData: PropTypes.bool.isRequired,
  data: PropTypes.object
};

AttachmentsSection.defaultProps = {
  data: {}
};

export default React.memo(AttachmentsSection);
